import React from 'react';

/**
 * AggTile — single aggregated KPI card displayed in the top row of
 * GlobalSupervisionTab. Extracted to its own file 29/05/2026.
 */
export default function AggTile({ testId, label, value, icon: Icon, color }) {
  return (
    <div className="bg-ink-800 border border-ink-600 rounded-lg p-3" data-testid={testId}>
      <div className="flex items-center gap-1.5 text-[9px] font-mono uppercase tracking-wider text-slate-500 mb-1">
        <Icon className="w-3 h-3" /> {label}
      </div>
      <p className={`text-xl font-black font-mono ${color}`}>{value}</p>
    </div>
  );
}
